export function setItemInLocalStorage(key: string, value: any) {
  localStorage.setItem(key, value);
}

export function getItemFromLocalStorage(key: string) {
  return localStorage.getItem(key);
}

export function removeItemFromLocalStorage(key: string) {
  return localStorage.removeItem(key);
}
